import { useEffect } from 'react'
import { X } from 'react-feather'
import styled, { css, useTheme } from 'styled-components/macro'

import { useRemovePopup } from '../../state/application/hooks'
import { PopupContent } from '../../state/application/reducer'
import FailedNetworkSwitchPopup from './FailedNetworkSwitchPopup'
import TransactionPopup from './TransactionPopup'

const StyledClose = styled(X)<{ $offset: number }>`
  position: absolute;
  right: ${({ $offset }) => `${$offset}px`};
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`
const PopupCss = css<{ show: boolean }>`
  display: inline-block;
  width: 100%;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  background: ${({ theme }) => theme.backgroundSurface};
  position: relative;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadow1};
  transition: ${({ theme }) => `visibility ${theme.transition.duration.fast} ease-in-out`};

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToSmall`
    min-width: auto;
  `};
`

const TransactionPopupContainer = styled.div`
  ${PopupCss}
  display: flex;
  padding: 0;
  align-items: stretch;
`

const FailedSwitchNetworkPopupContainer = styled.div<{ show: boolean }>`
  ${PopupCss}
  padding: 14px 18px;
`

export default function PopupItem({
  removeAfterMs,
  content,
  popKey,
}: {
  removeAfterMs: number | null
  content: PopupContent
  popKey: string
}) {
  const removePopup = useRemovePopup()
  const theme = useTheme()

  useEffect(() => {
    if (removeAfterMs === null) return undefined

    const timeout = setTimeout(() => {
      removePopup(popKey)
    }, removeAfterMs)

    return () => {
      clearTimeout(timeout)
    }
  }, [popKey, removeAfterMs, removePopup])

  if ('txn' in content) {
    return (
      <TransactionPopupContainer show={true}>
        <TransactionPopup hash={content.txn.hash} />
        <StyledClose $offset={12} color={theme.textSecondary} onClick={() => removePopup(popKey)} />
      </TransactionPopupContainer>
    )
  } else if ('failedSwitchNetwork' in content) {
    return (
      <FailedSwitchNetworkPopupContainer show={true}>
        <StyledClose $offset={16} color={theme.textSecondary} onClick={() => removePopup(popKey)} />
        <FailedNetworkSwitchPopup chainId={content.failedSwitchNetwork} />
      </FailedSwitchNetworkPopupContainer>
    )
  }
  return null
}
